import React from "react";

import { RankedTableDataProps } from "components/ranked-table/types";

import DesktopChart from "../../../ranked-table/desktop-chart";
import MobileChart from "../../../ranked-table/mobile-chart";
import { defaultDesignAppsList, defaultDesignFeatures } from "./features";

const chartTitle = "Solar Design Tools & Services";

type DesignAppsChartProps = RankedTableDataProps & {
  className?: string;
};
const DesignAppsChart = ({
  features: designAppFeatures,
  integratorsList: designApps,
  ...rest
}: DesignAppsChartProps) => {
  const loadedData = !!designAppFeatures?.length && !!designApps?.length;
  const chartProps = {
    features: loadedData ? designAppFeatures : defaultDesignFeatures,
    integratorsList: loadedData ? designApps : defaultDesignAppsList,
  };
  return (
    <>
      <DesktopChart title={chartTitle} {...chartProps} {...rest} />
      <MobileChart title={chartTitle} {...chartProps} {...rest} />
    </>
  );
};

export default DesignAppsChart;
